interface EnvVariables {
  APP_INSIGHTS_CONN_STRING: string;
  PORTAL_BACKEND_BASE_URI: string;
  PORTAL_REDIRECT_URI: string;
  APP_VERSION: string;
  PAGE_TITLE: string;
  HELP_CENTER_URI: string;
}

export const importEnvVariable = (variableName: string): string =>
  (import.meta.env[variableName] as string | undefined) ?? "";

const importVariables = () => ({
  APP_INSIGHTS_CONN_STRING: importEnvVariable("REACT_APP_APP_INSIGHTS_CONN_STRING"),
  PORTAL_BACKEND_BASE_URI: importEnvVariable("REACT_APP_PORTAL_BACKEND_BASE_URI"),
  PORTAL_REDIRECT_URI: importEnvVariable("REACT_APP_PORTAL_REDIRECT_URI"),
  APP_VERSION: importEnvVariable("REACT_APP_VERSION"),
  PAGE_TITLE: importEnvVariable("REACT_APP_PAGE_TITLE"),
  HELP_CENTER_URI: "https://help.entrilia.com/",
});

let variables: EnvVariables | undefined = undefined;

export const getSharedVariables = (): EnvVariables => {
  if (variables === undefined) {
    variables = importVariables();
  }
  return variables;
};

export const getBackendBaseUrl = (segment: string): string => {
  const localServerUrl =
    importEnvVariable(`REACT_APP_LOCAL_SERVER_${segment.toUpperCase()}`) || importEnvVariable("REACT_APP_LOCAL_SERVER");

  if (localServerUrl) {
    return localServerUrl;
  }

  return `${getSharedVariables().PORTAL_BACKEND_BASE_URI}/${segment}`;
};
